import React from 'react';
import styled from 'styled-components';
import { BrandLogo, Col, Container, Headline2, Row } from 'venn-ui-kit';
import type { SearchMenuItem } from 'venn-components';
import { getDisabledPortfolioTooltipMessage, SearchMenuBar } from 'venn-components';
import {
  hasAnalysisSubjectNoReturns,
  PORTFOLIO_LAB_OPTIONS_NEGATIVE_ALLOCATIONS_CASH_POSITIONS_DISABLED_MESSAGE,
} from 'venn-utils';
import { isNil } from 'lodash';

interface EmptyPortfolioLabPageProps {
  onSelectPortfolioId: (id: number) => void;
}

const EmptyPortfolioLabPage = ({ onSelectPortfolioId }: EmptyPortfolioLabPageProps) => {
  return (
    <Wrapper>
      <BrandLogo height={300} isBackground scaleToFit isDark topOffset={170} />
      <Container fluid>
        <Row>
          <Col xs={{ span: 8, offset: 2 }}>
            <Headline2 center>Select a portfolio to start optimizing</Headline2>
            <SearchMenuBar
              portfoliosOnly
              onSelected={({ value: selectedItem }: SearchMenuItem) => {
                if (!selectedItem) {
                  return;
                }
                if (!isNil(selectedItem.portfolio?.id)) {
                  onSelectPortfolioId(selectedItem.portfolio.id);
                }
              }}
              optionDisabledTooltipContent={(option) => {
                if (hasAnalysisSubjectNoReturns(option.value)) {
                  return 'This item has no returns and cannot be analyzed';
                }
                if (option.value?.isHistoricalPortfolio) {
                  return getDisabledPortfolioTooltipMessage(option);
                }
                if (option.value?.isLeverageShort || option.value?.hasOptions) {
                  return PORTFOLIO_LAB_OPTIONS_NEGATIVE_ALLOCATIONS_CASH_POSITIONS_DISABLED_MESSAGE;
                }
                return '';
              }}
              isOptionDisabled={(option) =>
                hasAnalysisSubjectNoReturns(option.value) ||
                !!option.value?.isHistoricalPortfolio ||
                !!option.value?.isLeverageShort ||
                !!option.value?.hasOptions
              }
              location="emptyPortfolioLabPage"
              privateAssetSearchMode="PUBLIC_ONLY"
            />
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default EmptyPortfolioLabPage;

const Wrapper = styled.div`
  padding-top: 220px;
  position: relative;
  height: 75vh;
  width: 100%;

  & > svg {
    top: 170px;
  }
`;
